export const IButtonTypeEnum = {
  Outlined: "OUTLINED",
  Text: "TEXT",
  Solid: "SOLID",
};
